import { render } from "./in-grid-banner.vue?vue&type=template&id=2eb632c1"
import script from "./in-grid-banner.vue?vue&type=script&lang=js"
export * from "./in-grid-banner.vue?vue&type=script&lang=js"

import "./in-grid-banner.vue?vue&type=style&index=0&id=2eb632c1&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__